export const ICONS = [
  { name: 'whats-app', path: '../../../assets/images/whatsapp.svg' },
  { name: 'whats-app-white', path: '../../../assets/images/whatsappWhite.svg' },
  { name: 'infinity-light', path: '../../../assets/images/infinity-light.svg' },
  { name: 'infinity-dark', path: '../../../assets/images/infinity-dark.svg' },
  { name: 'map-user', path: '../../../assets/images/map-user.svg' },
  { name: 'wallet', path: '../../../assets/images/wallet.svg' },
  { name: 'wallet-light', path: '../../../assets/images/wallet-light.svg' },
  { name: 'file', path: '../../../assets/images/file.svg' },
  { name: 'export', path: '../../../assets/images/export.svg' },
  { name: 'download', path: '../../../assets/images/download.svg' },
  { name: 'visibility', path: '../../../assets/images/visibility.svg' },
  { name: 'tags', path: 'assets/images/tags.svg' },
  { name: 'add', path: 'assets/images/add.svg' },
  { name: 'pharmacy', path: 'assets/images/pharmacy.svg' },
  { name: 'approve', path: 'assets/images/approve.svg' },
  { name: 'Pending', path: 'assets/images/pending.svg' },
  { name: 'approve-purchase', path: 'assets/images/approve-purchase.svg' },
  { name: 'reject', path: 'assets/images/reject.svg' },
  { name: 'partial-reject', path: 'assets/images/partial-reject.svg' },
  { name: 'location', path: 'assets/images/location.svg' },
  { name: 'add-square', path: 'assets/images/add-square.svg' },
  { name: 'trash', path: 'assets/images/trash.svg' },
  { name: 'down', path: 'assets/images/down.svg' },
  { name: 'delete', path: 'assets/images/delete.svg' },
  { name: 'bill-delete', path: 'assets/images/bill-delete.svg' },
  { name: 'upi', path: 'assets/images/UPI.svg' },
  { name: 'notes', path: 'assets/images/notes.svg' },
  { name: 'card', path: 'assets/images/card.svg' },
  { name: 'cash', path: 'assets/images/cash.svg' },
  { name: 'page-link', path: 'assets/images/page-link.svg' },
  { name: 'addMedicine', path: 'assets/images/add-medicine.svg' },
  { name: 'file-text', path: 'assets/images/file-text.svg' },
  { name: 'service-bills', path: 'assets/images/Service-bills.svg' },
  { name: 'Service', path: 'assets/images/Services.svg' },
  { name: 'ServiceW', path: 'assets/images/ServicesW.svg' },
  { name: 'service-bills-W', path: 'assets/images/BIllW.svg' },
  { name: 'offer-discount', path: 'assets/images/discount_ticket.svg' },
  { name: 'packageIcon', path: 'assets/images/package-icon.svg' },

  { name: 'free', path: 'assets/images/free.svg' },
  { name: 'free-fade', path: 'assets/images/free-fade.svg' },

  { name: 'activity-dark', path: 'assets/images/activity-log-dark.svg' },
  { name: 'activity-light', path: 'assets/images/activity-log-white.svg' },

  { name: 'ipd', path: 'assets/images/ipd.svg' },

  { name: 'prescription', path: 'assets/images/prescription.svg' },

  { name: 'lock', path: 'assets/images/Key.svg' },

  { name: 'import-service', path: 'assets/images/import.svg' },

  { name: 'delete-import', path: 'assets/images/delete-import.svg' },

  { name: 'excel', path: 'assets/images/excel.svg' },

  { name: 'pos', path: 'assets/images/posMachine.svg' },

  { name: 'payment-successful', path: 'assets/images/Payment-successful.svg' },

  { name: 'payment-failed', path: 'assets/images/Payment-failed.svg' },

  { name: 'card-swiping', path: 'assets/images/card-swiping.svg' },

  { name: 'office-note', path: 'assets/images/Office-Notepad.svg' },
  { name: 'doctor', path: 'assets/images/doctor.svg' },
  { name: 'union', path: 'assets/images/Union.svg' },
  { name: 'appointment-date', path: 'assets/images/appointment-date.svg' },
  { name: 'slotNotPresent', path: 'assets/images/slotNotPresent.svg' },

  { name: 'degree', path: 'assets/images/degree.svg' },
  { name: 'remove-pres', path: 'assets/images/remove-pres.svg' },

  { name: 'add-pres', path: 'assets/images/add-pres.svg' },
  { name: 'stethoscope', path: 'assets/images/stethoscope.svg' },
  { name: 'gateWay', path: 'assets/images/Gateway.svg' },
  { name: 'paymentLink', path: 'assets/images/paymentLink.svg' },

  { name: 'ipd-medicine', path: 'assets/images/ipd-medicine.svg' },

  { name: 'ipd-service', path: 'assets/images/ipd-service.svg' },

  { name: 'ipd-edit', path: 'assets/images/ipd-edit.svg' },

  { name: 'Icon', path: 'assets/images/Icon.svg' },
  { name: 'banner-app', path: 'assets/images/banner-app-color.svg' },
  { name: 'banner-app-light', path: 'assets/images/banner-app.svg' },
  { name: 'upload', path: 'assets/images/upload.svg' },
  { name: 'external-link', path: 'assets/images/external-link.svg' },

  { name: 'ipdIssues', path: 'assets/images/ipdPaymentMode.svg' },
  { name: 'patient-sticker', path: 'assets/images/ipd-sticker.svg' },
  { name: 'medicine-barcode', path: 'assets/images/medicine-barcode.svg' },
  { name: 'barcode-print', path: 'assets/images/barcode-print.svg' },

  { name: 'refund-details', path: 'assets/images/refund-details.svg' },
  { name: 'refnd_B', path: 'assets/images/Refnd_B.svg' },
  { name: 'refnd_W', path: 'assets/images/Refnd_W.svg' },
  { name: 'file_folder', path: 'assets/svgIcons/Folder.svg' },
  { name: 'doc', path: 'assets/svgIcons/Doc.svg' },
  { name: 'csv', path: 'assets/svgIcons/CSV.svg' },
  { name: 'pdf', path: 'assets/svgIcons/PDF.svg' },
  { name: 'video', path: 'assets/svgIcons/VIDEO.svg' },
  { name: 'ps-b', path: 'assets/images/ps-b.svg' },
  { name: 'ps-w', path: 'assets/images/ps-w.svg' },
  { name: 'cashRecoB', path: 'assets/images/cashReco.svg' },
  { name: 'cashRecoW', path: 'assets/images/cashRecoW.svg' },

  { name: 'sub-store', path: 'assets/images/sub-store.svg' },
  {
    name: 'payoutClamInformation',
    path: 'assets/images/payoutClamInformation.svg',
  },
  { name: 'payoutCost', path: 'assets/images/payoutCost.svg' },
  { name: 'payoutBill', path: 'assets/images/payoutBill.svg' },
  { name: 'file_folder', path: 'assets/svgIcons/Folder.svg' },
  { name: 'doc', path: 'assets/svgIcons/Doc.svg' },
  { name: 'csv', path: 'assets/svgIcons/CSV.svg' },
  { name: 'pdf', path: 'assets/svgIcons/PDF.svg' },
  { name: 'video', path: 'assets/svgIcons/VIDEO.svg' },
  { name: 'ps-b', path: 'assets/images/ps-b.svg' },
  { name: 'ps-w', path: 'assets/images/ps-w.svg' },
  { name: 'cashRecoB', path: 'assets/images/cashReco.svg' },
  { name: 'cashRecoW', path: 'assets/images/cashRecoW.svg' },
  { name: 'storeB', path: 'assets/images/StoreB.svg' },

  { name: 'payoutB', path: 'assets/images/Payout B.svg' },
  { name: 'payoutW', path: 'assets/images/Payout W.svg' },
  { name: 'stock-dispatch', path: 'assets/images/stock-dispatch.svg' },
];
